import type { ReactNode } from 'react';

// Kicker — small uppercase tertiary label rendered above section titles, KPIs,
// or anywhere the design philosophy specifies a 11px kicker. Uses the global
// `.kicker` recipe so all kickers stay consistent across the app.
type KickerProps = {
  children: ReactNode;
  className?: string;
};

export function Kicker({ children, className }: KickerProps) {
  const cls = ['kicker', className].filter(Boolean).join(' ');
  return <span className={cls}>{children}</span>;
}
